/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'EN': {
    width: 16,
    height: 16,
    viewBox: '0 0 15 11',
    data: '<clipPath id="svgicon-EN-a"><path pid="0" d="M14.75 2.25c0-1.097-.903-2-2-2H2.25c-1.097 0-2 .903-2 2v6.5c0 1.097.903 2 2 2h10.5c1.097 0 2-.903 2-2v-6.5z"/></clipPath><g clip-path="url(#svgicon-EN-a)"><path pid="1" _fill="#0a17a7" d="M0 0h15v11H0z"/><path pid="2" d="M3.47 7.333H0V3.667h3.47L-1.496.317-.677-.9l6.391 4.311V-.733h3.572V3.41l6.39-4.31.82 1.215-4.967 3.35H15v3.667h-3.47l4.967 3.35-.82 1.217-6.391-4.311v4.144H5.714V7.59l-6.39 4.31-.82-1.215 4.967-3.35-.001-.002z" _fill="#fff"/><path pid="3" d="M10 3.483L16.787-1.1m-6.066 8.633l6.083 4.21M4.289 3.47L-2.056-.918m7.033 8.401l-7.033 4.787" _fill="none" _stroke="#db1f35" stroke-width=".67"/><path pid="4" d="M0 6.6h6.429V11H8.57V6.6H15V4.4H8.571V0H6.43v4.4H0v2.2z" _fill="#e6273e"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/components/icons/EN.js